<template>
<b-card header="External Products" v-if="externalProducts.length > 0">
  <b-row v-for="item in externalProducts" :key="rowId(item)">
    <b-col md=6 class="d-flex flex-column justify-content-center">
      <p>
        <b><data-merger :dict=item.sku title="SKU" /></b><br/>
        <data-merger :dict=item.qty title="Quantity" />x <data-merger :dict=item.waterjetId title="Custom Job ID" /><br/>
        <data-merger :dict=item.waterjetThickness title="Thickness" /> <data-merger :dict=item.waterjetMaterial title="Material" /><br/>
        <data-merger :dict=item.waterjetShipping title="Priority" /><br/>
        <data-merger :dict=item.waterjetStatus title="Status" /> /
        <nice-date v-if="waterjetEstimate(item)" :value="waterjetEstimate(item)" :showTime="false" />
        <span v-else>No Estimated Date</span>
      </p>
    </b-col>
    <b-col md=6 class='d-flex flex-column justify-content-center'>
      <a :href="`https://waterjet.team221.com/image/${rowId(item)}`" target=_blank>
        <img class='mx-5' :src="`https://waterjet.team221.com/image/${rowId(item)}`" style="max-height: 150px" />
      </a>
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import NiceDate from '../../utility/NiceDate.vue'
import DataMerger from '../../utility/DataMerger.vue'
import orderMerge from '../../../services/orderMerge';

export default {
  props: {
    order: { type: Object, required: true },
  },
  components: {
    NiceDate,
    DataMerger
  },
  data() {
    return {
      externalProducts: [],
    };
  },
  mounted() {
    this.externalProducts = this.order.items.filter(item => !!item.waterjetId)
  },
  methods: {
    rowId(row) {
      return orderMerge.mergeField(row.waterjetId)
    },
    waterjetEstimate(row) {
      return orderMerge.mergeField(row.waterjetEstimate)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/ExternalProducts.vue